<template>
  <div class="foot">
    <div class="server-list">
      <div id="block1" class="block">
        <router-link
          to="/products"
          class="list-item"
        >
          <img
            class="list-item-icon"
            src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/09221916nq9h.png"
            alt=""
          >
          <p class="list-item-title">产品中心</p>
        </router-link>
      </div>
      <div id="block2" class="block">
        <router-link
          to="/solutions"
          class="list-item"
        >
          <img
            class="list-item-icon"
            src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/09222201ma47.png"
            alt=""
          >
          <p class="list-item-title">服务中心</p>
        </router-link>
      </div>
      <div id="block4" class="block">
        <router-link
          to="/successcase"
          class="list-item"
        >
          <img
            class="list-item-icon"
            src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/09222952p6x4.png"
            alt=""
          >
          <p class="list-item-title">成功案例</p>
        </router-link>
      </div>
      <div id="block5" class="block">
        <router-link
          to="/aboutUs"
          class="list-item"
        >
          <img
            class="list-item-icon"
            src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/09223219vgmh.png"
            alt=""
          >
          <p class="list-item-title">关于我们</p>
        </router-link>
      </div>
    </div>
    <div class="bottom-txt">
      <p>地址：中国（江苏）自由贸易试验区苏州片区苏州工业园区裕新路168号脉山龙大厦1幢409-13室</p>
      <p>Copyright©苏州睿泽信息技术有限公司</p>
    </div>
    <div>
      <hr class="my-4" style="width:800px;color:grey;margin:0 auto;">
    </div>
  </div>
</template>
<script>
export default {
  name: 'MyFooter',
  data() {
    return {}
  }
}
</script>
<style scoped>
.bottom-txt {
  color: ivory;
  opacity: 0.7;
}
.foot {
  background-color: rgb(7, 2, 59);
  padding: 40px 8% 5px 8%;
  right: 0;
  left: 0;
  bottom: 0;
  vertical-align: bottom;
  width: 100%;
}

.server-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 20px 0 30px 0;
  /* width: 1200px; */
}

.server-list a {
  text-decoration: none;
  width:200px;
  text-align: center;
}

.list-item {
  display: flex;
  flex-direction: row;
  width: 10%;
  padding-left: 20%;
  transition: all .4s ease;
  opacity: .7;
}

.list-item:hover {
  opacity: 1;
}

.list-item-icon {
  padding-right: 15px;
}

.list-item-title {
  text-align: center;
  margin:0;
  color:ivory;
}

.block:hover {
  opacity: 1;
}

.block {
  padding: 20 10px 20 10px;
  text-align: center;
  /* width: 240px; */
}

.foot-frame {
  padding-top:30px;
  display: flex;
  max-width: 1200px;
  margin:auto;
  /* background-color: whitesmoke; */
}

.left {
  width: 20%;
}

.right {
  width: 80%;
  background-color: rgba(0, 0, 0, 0);
  display: flex;
}

.right-cell {
  width:25%;
  /* border: 1px solid white; */
}

li {
  list-style: none;
  text-align: left;
  color: #9497b4;
  margin:2px;
  font-size: 16px;
  line-height: 50px;
}

#num {
  color:whitesmoke;
  font-weight: bold;
  font-size: 1.4rem;
}

li h5 {
  color: whitesmoke;
  font-size: 1.15rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue